/*
 * Copyright (c) 2026. Orion Analytics.
 */

export default function AnalyticsCard({
    title,
    children
}) {

    return (

        <div
            className="
                bg-white
                rounded-3xl
                border
                border-slate-200
                shadow-sm
                overflow-hidden
                h-full
            "
        >

            <div className="
                px-6
                py-4
                border-b
                border-slate-100
            ">

                <h3 className="
                    text-lg
                    font-semibold
                    text-slate-900
                ">
                    {title}
                </h3>

            </div>

            <div className="
                p-4
                flex
                justify-center
                items-center
                overflow-hidden
            ">

                {children}

            </div>

        </div>
    );
}